import React from 'react';
import i18n from 'i18next';
import { css } from '@emotion/core';
import querystring from 'query-string';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import FeverIconButton from 'components/common/Button/FeverIconButton';
import usePromoSettingThemeStyle from 'hooks/useThemeStyleIntegration';
import { IS_IFRAME_MODE } from 'config/envVariable';

const TaskRecordHeader = ({ promoUuid, taskUuid }) => {
    const themeStyle = usePromoSettingThemeStyle();
    const handleRedirectToParentUrl = () => {
        const queryParams = querystring.parse(window.location.search);
        const qs = createQueryString(queryParams);
        const taskReferrerUrl = createTaskReferrerUrl(promoUuid, qs);
        redirectToUrl(taskReferrerUrl);
    };
    // [#86erauggn] 只要流程帶著指定參數，左上角都顯示返回按鈕
    const shouldBackToMultiChallengeTaskPromoBtn = promoUuid && taskUuid;

    const createQueryString = ({ test_code, test_expired }) => {
        return test_code && test_expired
            ? `?${querystring.stringify({ test_code, test_expired })}`
            : '';
    };

    const createTaskReferrerUrl = (promoUuid, queryString) => {
        return `https://${window.location.host}/r/promotions/p/${promoUuid}${queryString}`;
    };

    const redirectToUrl = url => {
        if (IS_IFRAME_MODE) {
            window.top.location.href = url;
        } else {
            window.location.href = url;
        }
    };

    return (
        <div css={taskRecordHeaderContainerStyle}>
            {shouldBackToMultiChallengeTaskPromoBtn && (
                <FeverIconButton
                    variant="text"
                    text={i18n.t('label.back_to.task_card')}
                    textColor={themeStyle.buttonBgColor}
                    icon={ArrowLeftIcon}
                    iconVariant="default"
                    iconPosition="start"
                    iconSize={24}
                    buttonStyle={customButtonStyle(themeStyle.buttonBgColor)}
                    onClick={handleRedirectToParentUrl}
                    disableTouchRipple={true}
                />
            )}
        </div>
    );
};

export default TaskRecordHeader;

const customButtonStyle = color => css`
    background-color: transparent;
    padding: 8px;

    & .MuiBox-root {
        margin-right: 4px;

        & .MuiIconButton-root {
            padding: 0;
        }

        & .MuiSvgIcon-root {
            color: ${color};
        }
    }

    &:hover {
        background-color: transparent;
    }

    &:active {
        box-shadow: none;
    }
`;

const taskRecordHeaderContainerStyle = css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;
